module.exports = __webpack_public_path__ + "static/media/donate.1932b3f0.svg";